import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PrinterService {

    static BODY_CLASS_WHILE_PRINTING = 'printing';
    static PRINT_ELEMENT_ID = 'printable';

    public async print() {
        document.body.classList.add(PrinterService.BODY_CLASS_WHILE_PRINTING);
        let printData = document.getElementById(PrinterService.PRINT_ELEMENT_ID).cloneNode(true);
        document.body.appendChild(printData);
        window.print();
        document.body.removeChild(printData);
        document.body.classList.remove(PrinterService.BODY_CLASS_WHILE_PRINTING);
    }

}
